<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <a href="index.html" class="btn btn-icon btn-soft-primary"
        ><font-awesome-icon icon="home"
      /></a>
    </div>
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-5">
            <div class="mr-lg-5">
              <h2 class="title mb-3">Dobrodošli pri raziskavi ...</h2>
              <div v-html="project.description"></div>
              <div v-if="project.desc_img">
                <img
                  :src="helperImgPath(project.desc_img)"
                  class="img-fluid d-block mx-auto mt-4"
                  :alt="project.title"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/images/illustrator/analyze_report_4.svg"
                  class="img-fluid d-block mx-auto mt-4"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="card login_page shadow rounded border-0">
              <div class="card-body">
                <UserData />
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import UserData from "@/components/UserData.vue";
import moment from "moment";
moment.locale("en");
export default {
  components: { UserData },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      respondentId: (state) => state.api.respondentId,
      project: (state) => state.api.currentProject,
    }),
  },

  created() {
    let projectSlug = this.$route.params.projectSlug;

    if (this.respondentId) {
      // TODO: if package
      this.$router.push({
        name: "IntroPage",
        params: { projectSlug: projectSlug },
      });
    }
  },
  mounted() {},
  methods: {
    helperImgPath: function(img) {
      return `${this.$store.state.api.url}/uploads/${this.$store.state.api.currentProject.id}/help_images/${img}`;
    },
  },
};
</script>
